<template>
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="20 20 180 180"
      fill="#FFF"
      stroke="currentColor"
   >
      <defs id="defs4302">
         <clipPath id="clipPath4429">
            <g transform="matrix(0.9947658,0,0,1,1.7860989,0)" id="g4431">
               <path
                  d="m 322.54143,2800.9375 -4.43505,5.7298 -4.43495,-5.7298 0,-43.1429 -18.93972,0 23.37467,-25.5367 23.13125,25.5367 -18.6962,0 0,43.1429 z"
                  id="path4433"
                  style="fill:#efa724;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:30;marker:none;visibility:visible;display:inline;overflow:visible"
               />
            </g>
         </clipPath>
      </defs>
      <g transform="translate(-64.032001,-432.25134)" id="layer1">
         <g transform="matrix(1.0008826,0,0,1.0094534,-0.05651152,-6.184848)" id="g5189">
            <g transform="matrix(1.0627252,0,0,1.0537063,198.76454,-518.47507)" id="g3664">
               <g transform="matrix(0,-1,1,0,-1934.5199,1337.4805)" id="g12802">
                  <g transform="translate(16.279512,-899.16723)" id="g12804">
                     <g transform="matrix(1.0666663,0,0,1,-26.935596,-4.1328125e-5)" id="g12806">
                        <path
                           d="m 323.36653,2798.1614 -5.40616,5.8005 -5.40616,-5.8005 0,-40.8261 -18.01333,0 23.41949,-24.8979 23.02487,24.8979 -17.6187,0 -10e-6,40.8261 z"
                           id="path12808"
                           style="fill:#932279;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:30;marker:none;visibility:visible;display:inline;overflow:visible"
                        />
                     </g>
                     <g
                        transform="matrix(1.0722788,0,0,1,-28.850792,-4.1328125e-5)"
                        clip-path="url(#clipPath4429)"
                        id="g12812"
                     />
                  </g>
               </g>
               <g transform="translate(-351.30671,-902.55818)" id="g12768">
                  <g transform="translate(16.279512,-899.16723)" id="g12770">
                     <g transform="matrix(1.0666663,0,0,1,-26.935596,-4.1328125e-5)" id="g12772">
                        <path
                           d="m 323.36653,2798.1614 -5.40616,5.8005 -5.40616,-5.8005 0,-40.8261 -18.01333,0 23.41949,-24.8979 23.02487,24.8979 -17.6187,0 -10e-6,40.8261 z"
                           id="path12774"
                           style="fill:#efa724;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:30;marker:none;visibility:visible;display:inline;overflow:visible"
                        />
                     </g>
                     <g
                        transform="matrix(1.0722788,0,0,1,-28.850792,-4.1328125e-5)"
                        clip-path="url(#clipPath4429)"
                        id="g12778"
                     />
                  </g>
               </g>
               <g transform="matrix(0,1,-1,0,2787.8992,696.93451)" id="g12780">
                  <g transform="matrix(1.0666663,0,0,1,-26.935596,-4.1328125e-5)" id="g12782">
                     <path
                        d="m 323.36653,2798.1614 -5.40616,5.8005 -5.40616,-5.8005 0,-40.8261 -18.01333,0 23.41949,-24.8979 23.02487,24.8979 -17.6187,0 -10e-6,40.8261 z"
                        id="path12784"
                        style="fill:#262577;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:30;marker:none;visibility:visible;display:inline;overflow:visible"
                     />
                  </g>
                  <g
                     transform="matrix(1.0722788,0,0,1,-28.850792,-4.1328125e-5)"
                     clip-path="url(#clipPath4429)"
                     id="g12788"
                  />
               </g>
               <g transform="matrix(-1,0,0,-1,305.51863,2920.6937)" id="g12790">
                  <g transform="translate(16.279512,-899.16723)" id="g12792">
                     <g transform="matrix(1.0666663,0,0,1,-26.935596,-4.1328125e-5)" id="g12794">
                        <path
                           d="m 323.36653,2798.1614 -5.40616,5.8005 -5.40616,-5.8005 0,-40.8261 -18.01333,0 23.41949,-24.8979 23.02487,24.8979 -17.6187,0 -10e-6,40.8261 z"
                           id="path12796"
                           style="fill:#9ccd2a;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:30;marker:none;visibility:visible;display:inline;overflow:visible"
                        />
                     </g>
                     <g
                        transform="matrix(1.0722788,0,0,1,-28.850792,-4.1328125e-5)"
                        clip-path="url(#clipPath4429)"
                        id="g12800"
                     />
                  </g>
               </g>
               <g transform="translate(-749.79982,-1331.6428)" id="g12742">
                  <path
                     d="m 671.98437,2285.7893 49.60645,0 0,49.6065 -49.60645,0 0,-49.6065 z"
                     id="rect12744"
                     style="fill:#9ccd2a;fill-opacity:1;stroke:#ffffff;stroke-width:3.54330707;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dashoffset:0"
                  />
                  <path
                     d="m 732.22076,2285.7893 49.60645,0 0,49.6065 -49.60645,0 0,-49.6065 z"
                     id="rect12746"
                     style="fill:#932279;fill-opacity:1;stroke:#ffffff;stroke-width:3.54330707;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dashoffset:0"
                  />
                  <path
                     d="m 732.22076,2346.0256 49.60645,0 0,49.6065 -49.60645,0 0,-49.6065 z"
                     id="rect12748"
                     style="fill:#efa724;fill-opacity:1;stroke:#ffffff;stroke-width:3.54330707;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dashoffset:0"
                  />
                  <path
                     d="m 671.98437,2346.0256 49.60645,0 0,49.6065 -49.60645,0 0,-49.6065 z"
                     id="rect12750"
                     style="fill:#262577;fill-opacity:1;stroke:#ffffff;stroke-width:3.54330707;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dashoffset:0"
                  />
               </g>
               <path
                  d="m -784.62878,642.40875 49.60644,0 0,49.60645 -49.60644,0 0,-49.60645 z"
                  transform="matrix(0.7071068,-0.7071068,0.7071068,0.7071068,0,0)"
                  id="rect12760"
                  style="fill:none;stroke:#ffffff;stroke-width:3.54330707;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dashoffset:0"
               />
               <path
                  d="m -724.39233,642.40875 49.60645,0 0,49.60645 -49.60645,0 0,-49.60645 z"
                  transform="matrix(0.7071068,-0.7071068,0.7071068,0.7071068,0,0)"
                  id="rect12762"
                  style="fill:none;stroke:#ffffff;stroke-width:3.54306793;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0"
               />
               <path
                  d="m -15.377623,1009.0679 35.077058,-35.0771 35.077058,35.0771 -35.077058,35.077 -35.077058,-35.077 z"
                  id="rect12764"
                  style="fill:none;stroke:#ffffff;stroke-width:3.54330707;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dashoffset:0"
               />
               <path
                  d="m -784.62878,702.64508 49.60644,0 0,49.60645 -49.60644,0 0,-49.60645 z"
                  transform="matrix(0.7071068,-0.7071068,0.7071068,0.7071068,0,0)"
                  id="rect12766"
                  style="fill:none;stroke:#ffffff;stroke-width:3.54330707;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dashoffset:0"
               />
            </g>
         </g>
      </g>
   </svg>
</template>

<style lang="scss" scoped>
svg {
   display: block;
   path {
      stroke: none;
   }
   height: auto;
}
</style>
